// src/pages/teacher/TeacherSettings.tsx
// הגדרות חשבון גננת

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { User, Lock, Building2, Phone, LogOut, ArrowRight } from 'lucide-react';
import { teacherColors as colors } from '../../styles/colors';

export default function TeacherSettings() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto' }}>
      {/* Back */}
      <button
        onClick={() => navigate(-1)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '8px 0',
          backgroundColor: 'transparent',
          border: 'none',
          cursor: 'pointer',
          color: colors.primary,
          fontSize: '14px',
          fontWeight: '500',
          marginBottom: '16px',
        }}
      >
        <ArrowRight size={18} />
        חזרה
      </button>

      <h1 style={{ fontSize: '22px', fontWeight: 'bold', color: colors.text, marginBottom: '24px' }}>
        הגדרות
      </h1>

      {/* Profile Card */}
      <div style={{
        backgroundColor: colors.white,
        borderRadius: '14px',
        padding: '20px',
        border: `1px solid ${colors.border}`,
        marginBottom: '16px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{
            width: '52px',
            height: '52px',
            borderRadius: '14px',
            backgroundColor: colors.primaryLight,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <User size={24} color={colors.primary} />
          </div>
          <div>
            <p style={{ fontSize: '16px', fontWeight: '600', color: colors.text, margin: 0 }}>
              {user?.name || 'גננת'}
            </p>
            <p style={{ fontSize: '13px', color: colors.textLight, marginTop: '2px' }}>
              {user?.kindergartenName || ''}
            </p>
          </div>
        </div>
      </div>

      {/* Settings List */}
      <div style={{
        backgroundColor: colors.white,
        borderRadius: '14px',
        border: `1px solid ${colors.border}`,
        overflow: 'hidden',
        marginBottom: '16px',
      }}>
        {[
          { icon: Phone, label: 'פרטים אישיים', subtitle: user?.phone || '' },
          { icon: Building2, label: 'גן נוכחי', subtitle: user?.kindergartenName || '' },
          { icon: Lock, label: 'שינוי סיסמה', subtitle: '' },
        ].map((item, i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '14px',
              padding: '16px 20px',
              borderBottom: i < 2 ? `1px solid ${colors.border}` : 'none',
              cursor: 'pointer',
            }}
          >
            <item.icon size={20} color={colors.textLight} />
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: '14px', fontWeight: '500', color: colors.text, margin: 0 }}>{item.label}</p>
              {item.subtitle && (
                <p style={{ fontSize: '12px', color: colors.textLight, marginTop: '2px' }}>{item.subtitle}</p>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Logout */}
      <button
        onClick={handleLogout}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          padding: '14px',
          backgroundColor: '#fee2e2',
          color: '#dc2626',
          border: 'none',
          borderRadius: '14px',
          fontSize: '14px',
          fontWeight: '500',
          cursor: 'pointer',
        }}
      >
        <LogOut size={18} />
        התנתקות
      </button>

      {/* Version */}
      <p style={{
        textAlign: 'center',
        fontSize: '12px',
        color: colors.textLight,
        marginTop: '24px',
      }}>
        KipiKid Teacher v1.0
      </p>
    </div>
  );
}
